import { GetAction, PostAction } from './types'
import { API_GET, API_POST } from './actionTypes'

export const get = (url: string): GetAction => ({
  type: API_GET,
  url
})

export const post = (url: string, body: any): PostAction => ({
  type: API_POST,
  url, body
})
